import React from "react";

const en = {
	main: {
		siteTitle: "Reactfolio by Qodirxon Nodirxonov",
	},

	nav: {
		home: "Home",
		about: "About",
		projects: "Projects",
		skills: "Skills",
		articles: "Articles",
		contact: "Contact",
		resume: "Resume",
		resumeTitle: "Download resume",
	},

	lang: {
		uz: "UZ",
		en: "EN",
		ru: "RU",
	},

	footer: {
		credits: "© Nodirkhanov Qodirkhan",
	},

	titles: {
		about: "About",
		projects: "Projects",
		skills: "Skills",
		articles: "Articles",
		contact: "Contact",
	},

	homepage: {
		title: "I am Nodirkhanov Qodirkhan.",
		description:
			"I am a backend developer with expertise in React.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies. I enjoy solving complex problems and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
	},

	about: {
		title: "About Me",
		description: `Hi, I'm Qodirxon Nodirxonov, an 18-year-old passionate web developer born on February 15. I specialize in building modern, responsive, and dynamic web applications using the latest technologies.

With strong skills in React.js, JavaScript, Node.js, HTML, and CSS, I love turning ideas into reality through clean code and smooth user experiences. I'm always eager to learn, grow, and create meaningful digital solutions that make people's lives easier.

When I'm not coding, you can find me exploring new tech trends, contributing to open-source projects, or sharing my knowledge with the community. I believe in the power of collaboration and continuous learning to stay ahead in this ever-evolving field.
If you're looking for a dedicated and enthusiastic developer to bring your next project to life, feel free to reach out.
Let's build something great together!`,
	},

	articlesIntro: {
		title: "About the news in my life.",
		description:
			"I will be covering news from my life here in the form of articles.",
	},

	projectsPage: {
		title: "Things I’ve made trying to put my dent in the universe.",
		subtitle: `I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.`,
	},

	contact: {
		pageTitle: "Have an idea? Let’s bring it to life together.",
		lead:
			"A project, a collaboration offer or just a question — whatever it is, write to me. I read every message myself and always reply.",
		available: "Open to new projects",
		response: "I usually reply within 24 hours",
		cards: {
			email: "For official offers and collaboration",
			telegram: "The fastest way — I reply quickly here",
			instagram: "My daily life and updates",
			github: "My code and open projects",
		},
		write: "Write",
		closing:
			"The best projects start with a simple “hello”. Take the first step!",
	},

	socials: {
		telegram: "Follow on Telegram",
		github: "Follow on GitHub",
		instagram: "Follow on Instagram",
	},

	works: {
		cardTitle: "Study",
		entries: [
			{
				title: "22-school in Namangan",
				subtitle: "11 years",
				duration: "2015 - 2026",
			},
			{
				title: "Start 21 in Namangan",
				subtitle: "1 year | English",
				duration: "2024 - 2025",
			},
			{
				title: "Learning IT",
				subtitle: "Algoritm",
				duration: "2023 - 2025",
			},
			{
				title: "PDP University",
				subtitle: "Student",
				duration: "2026 - present",
			},
		],
	},

	articleLink: "Read article",

	projects: [
		{
			title: "Queue System — Sherdor Medical",
			description:
				"A complete electronic queue and management system for a clinic: kiosk, registration, cashier, laboratory, doctor and manager apps. Uzbek voice announcements on the waiting-room TV, SMS and Telegram notifications for patients, and QR verification of lab results. Works offline and syncs data to the server automatically. Built with Node.js, React, MongoDB, Electron and Android.",
			linkText: "View Project",
		},
		{
			title: "Project 1",
			description:
				"A Telegram Stars selling bot built for fast purchases and simple order flow. Users can buy Stars, track order status, and get quick support in one place. Bot link: @uzbstarsbuybot",
			linkText: "View Project",
		},
		{
			title: "Project 2",
			description:
				"A full-featured Telegram commerce bot where users can buy Premium, Stars, gifts, and NFTs. Built with React and PHP. Bot link: @milliydokonbot",
			linkText: "View Project",
		},
	],

	articles: [
		{
			date: "25.10.2026",
			title: "Navbat: how I built an electronic queue system for a clinic.",
			description:
				"From paper queues and a noisy waiting room to a kiosk, voice announcements on the TV and a manager app — how the Navbat system came to be…",
			keywords: ["Navbat", "queue system", "clinic", "Qodirkhan"],
			style: "",
			body: (
				<React.Fragment>
					<div className="article-content">
						<div className="paragraph">
							It all started with a simple observation: patients at the
							clinic waited in line on paper or by verbal agreement,
							arguments about who was next were common, and the registry
							desk was busy registering patients and managing the queue at
							the same time. So I decided to bring the clinic's entire
							workflow into one system — and that is how Navbat was born.
							<br />
							<br />
							The system consists of several apps. A patient takes a ticket
							at the kiosk or registers at the front desk. The cashier
							accepts payment, the laboratory enters test results, and the
							doctor calls the next patient from their office. The
							waiting-room TV shows queue numbers and announces each call by
							voice in Uzbek — patients don't have to stare at the screen.
							<br />
							<br />
							I added conveniences for patients too: SMS and Telegram
							notifications, and lab results that can be checked via a QR
							code on the receipt. For the clinic manager I wrote a separate
							Android app showing daily revenue, patient counts, room
							occupancy and reports from anywhere.
							<br />
							<br />
							Technically, it runs on a Node.js and MongoDB server, React
							web interfaces, Electron desktop apps and Android. This
							project taught me to design not just a single app, but a whole
							ecosystem that real people rely on every day.
						</div>
					</div>
				</React.Fragment>
			),
		},
		{
			date: "18.10.2026",
			title: "A system that works even when the internet is down: lessons from Navbat.",
			description:
				"Work at a clinic must not stop even if the internet goes down for an hour. On offline mode, automatic updates and backups…",
			keywords: ["Navbat", "offline", "backup", "Node.js", "Qodirkhan"],
			style: "",
			body: (
				<React.Fragment>
					<div className="article-content">
						<div className="paragraph">
							The most important lesson after launching Navbat was this: at
							a clinic, an internet outage is not a question of “if” but
							“when”. And patients don't wait. That's why the system runs
							first and foremost on a local server inside the clinic: the
							registry, cashier, laboratory and waiting-room TV keep talking
							to each other without the internet.
							<br />
							<br />
							When the connection returns, data syncs to the cloud server
							automatically. The hardest part is making sure no record is
							lost and none is written twice. I added unique identifiers for
							every receipt and payment, a retry queue and server-side
							duplicate protection. In a system that handles money, even one
							lost receipt is a big problem.
							<br />
							<br />
							Installing new versions on every computer by hand was
							impossible, so I wrote an auto-update mechanism: apps download
							and install new versions themselves, while data is kept
							separately in a safe place. Database backups are also sent to
							Telegram regularly, so data can be restored even if something
							happens to the server.
							<br />
							<br />
							This experience showed me that the most important thing in
							programming isn't pretty code but reliability: the system has
							to work every day, under any conditions. Navbat is still
							evolving, and each new version improves based on feedback from
							real users.
						</div>
					</div>
				</React.Fragment>
			),
		},
	],

	notFound: {
		title: "Oops!",
		message:
			"We can't seem to find the page you're looking for.\nThe requested URL \"{{url}}\" was not found on this server.",
		link: "Go back to the home page",
	},

	skillsPage: {
		title: "Technologies I work with.",
		subtitle: "I build web applications end to end — from the interface to the server — with these technologies, and use them every day in real projects like the Navbat queue system.",
		items: {
			html: "Semantic, accessible page structure and clean, SEO-friendly markup.",
			css: "Responsive design, Flexbox and Grid, animations and modern styling.",
			js: "The core language for browser and server: ES6+, async code, DOM.",
			react: "Fast interfaces with components, hooks and routing.",
			node: "Servers, real-time services, background jobs and desktop apps (Electron).",
			express: "REST APIs, middleware, authentication and file uploads.",
			python: "Automation scripts, Telegram bots and data processing.",
			cpp: "From the basics up to OOP: classes, inheritance, encapsulation and polymorphism.",
		},
	},

	seo: {
		home: {
			description:
				"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
			keywords: ["Qodirkhan", "Nodirkhanov", "portfolio", "developer"],
		},
		about: {
			description:
				"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
			keywords: ["Qodirkhan", "Nodirkhanov", "about"],
		},
		articles: {
			description:
				"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
			keywords: ["Qodirkhan", "articles", "blog"],
		},
		projects: {
			description:
				"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
			keywords: ["Qodirkhan", "projects", "open source"],
		},
		skills: {
			description:
				"Technologies used by Qodirxon Nodirxonov: HTML, CSS, JavaScript, React, Node.js, Express.js, Python, C++.",
			keywords: ["Qodirkhan", "skills", "React", "Node.js", "Python"],
		},
		contact: {
			description:
				"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
			keywords: ["Qodirkhan", "contact", "email"],
		},
	},
};

export default en;
